/**
 * @Description 益禾堂定制组件，配合集客点的商圈类型
 * https://confluence.lanhanba.com/pages/viewpage.action?pageId=132273933
 */

import { FC, useEffect, useState } from 'react';
// import { Form } from 'antd';
import { populationFlowYHTOfSelectOptions, setComValue } from '../config';
import { useMethods } from '@lhb/hook';
// import cs from 'classnames';
// import styles from './entry.module.less';
import V2FormSelect from '@/common/components/Form/V2FormSelect/V2FormSelect';
// import FormSetName from '@/common/components/Form/FormSetName';

interface PopulationFlowYHTProps {
  propertyItem: any;
  form: any;
  disabled: boolean;
  required: boolean;
  customGatheringCategoryForYHT: any;
}
const PopulationFlowYHT: FC<PopulationFlowYHTProps> = ({
  propertyItem,
  form,
  disabled,
  required,
  customGatheringCategoryForYHT,
}) => {

  const [labelVal, setLabelVal] = useState<string>(propertyItem?.anotherName || propertyItem?.name || '人口流量');
  const [targetOptions, setTargetOptions] = useState<any[]>([]);
  const restriction = propertyItem?.restriction ? JSON.parse(propertyItem.restriction) : {};
  const placeholder = restriction?.placeholder ? restriction.placeholder : `请选择`;
  const rules = [
    { required, message: placeholder },
  ];

  // 机会点表单创建机会点时创建集客点 || 机会点详情可编辑表单切换集客点 || 表单场景时的切换集客点（集客点的商圈类型不同时）
  useEffect(() => {
    if (!customGatheringCategoryForYHT) return;
    const { firstLevelCategory, isReset } = customGatheringCategoryForYHT;
    if (firstLevelCategory) {
      methods.handleRender(firstLevelCategory);
      return;
    }
    // 清空了选择时
    if (isReset) {
      const defaultLabel = propertyItem?.anotherName || propertyItem?.name;
      setLabelVal(defaultLabel);
      setTargetOptions([]);
      setComValue(propertyItem, {
        label: defaultLabel,
        options: [],
        value: '',
        targetCategory: ''
      });
      form.setFieldValue(propertyItem.identification, ''); // 清空之前值
    }
  }, [customGatheringCategoryForYHT]);
  useEffect(() => {
    if (!form) return;
    const { textValue, identification } = propertyItem || {};
    if (textValue && typeof (textValue) === 'string') {
      const targetVal = JSON.parse(textValue);
      if (!(targetVal && Object.keys(targetVal).length)) return;
      const { label, options, value } = targetVal;
      setLabelVal(label);
      setTargetOptions(options);
      form.setFieldValue(identification, value); // 赋值
    }
  }, [propertyItem, form]);

  const methods = useMethods({
    handleRender: (firstLevelCategory: string) => {
      const target = populationFlowYHTOfSelectOptions.find((item: any) => item.value.includes(firstLevelCategory));
      if (!target) return;
      const { label, options } = target || {};
      form.setFieldValue(propertyItem.identification, ''); // 清空之前值
      // 选集客点选其他类型时，默认用组件配置的名字
      const targetLabel = label || propertyItem?.anotherName || propertyItem?.name;
      setLabelVal(targetLabel);
      setTargetOptions(options);
      setComValue(propertyItem, {
        label: targetLabel,
        options,
        value: '',
        targetCategory: firstLevelCategory
      });
    },
    handleChange: (value: number) => {
      setComValue(propertyItem, {
        value
      });
    }
  });
  return (
    <>
      <V2FormSelect
        label={labelVal}
        name={propertyItem.identification}
        placeholder={placeholder}
        options={targetOptions}
        disabled={disabled}
        required
        rules={rules}
        config={{
          getPopupContainer: (node) => node.parentNode,
        }}
        onChange={methods.handleChange}
      />
    </>
  );
};

export default PopulationFlowYHT;
